import {
  ContentIndexTypeEnum,
  ContentTypeEnum,
  IStaticContext,
  IStaticData,
  TitleLevelEnum,
} from "@/static/dataType";

const data: Array<IStaticData> = [
  {
    title: {
      text: "Safie Developers（当サイト）について",
    },
    content: [
      {
        text: "当サイトは、セーフィーのクラウド録画サービスとのデータ連携を可能とする開発者向けサイトです。目的や用途に合わせたWebサービスやアプリケーションの開発を柔軟に行うことができます。",
      },
    ],
  },
  {
    title: {
      text: "当サイトでできること",
    },
    content: [
      {
        text: "Safie APIおよびSafie SDK(JavaScript)を利用するのに必要なディベロッパーとしての情報を登録できます。",
        indexType: ContentIndexTypeEnum.circle,
      },
      {
        text: "APIキーおよびOAuth2.0の認証キーを取得し、アプリケーション開発を始めることができます。",
        indexType: ContentIndexTypeEnum.circle,
      },
    ],
  },
  {
    title: {
      text: "Safie Developers 登場人物",
    },
    content: [
      {
        type: ContentTypeEnum.image,
        styleObject: { marginLeft: "24px" },
        image: {
          pcUrl: require("./images/characters.png"),
          pcMaxWidth: "600px",
          pcWidth: "100%",
          spUrl: require("./images/characters.png"),
          spWidth: "319px",
          spMaxWidth: "319px",
        },
      },
    ],
  },
  {
    title: {
      text: "アプリケーション開発開始までのステップ",
    },
    children: [
      {
        title: {
          text: "新規ユーザー登録（サインアップ）",
          titleIndex: "1.",
          level: TitleLevelEnum.second,
        },
        content: [
          {
            text: "ご利用にあたってはSafieユーザーとしての登録が必要です。",
            styleObject: { marginLeft: "24px" },
          },
          {
            text: "既にSafieをご利用の方は、そのアカウントのメールアドレスとパスワードでログインしてください。",
            styleObject: { marginTop: "0px", marginLeft: "24px" },
          },
          {
            text: "初めての方は、<a class='is-static-link' href='/signup' target='_blank'>こちら</a>から新規ユーザー登録を行ってください。",
            styleObject: { marginTop: "0px", marginLeft: "24px" },
            type: ContentTypeEnum.link,
          },
          {
            type: ContentTypeEnum.image,
            styleObject: { marginLeft: "24px" },
            image: {
              pcUrl: require("./images/signup.png"),
              pcMaxWidth: "600px",
              pcWidth: "100%",
              spUrl: require("./images/signup-sp.png"),
              spWidth: "319px",
              spMaxWidth: "319px",
            },
          },
          {
            text: "初回ログイン時に担当者情報をご入力ください。",
            styleObject: { marginLeft: "24px" },
          },
          {
            type: ContentTypeEnum.image,
            styleObject: { marginLeft: "24px" },
            image: {
              pcUrl: require("./images/userinfo.png"),
              pcMaxWidth: "600px",
              pcWidth: "100%",
              spUrl: require("./images/userinfo-sp.png"),
              spWidth: "319px",
              spMaxWidth: "319px",
            },
          },
        ],
      },
      {
        title: {
          text: "アプリケーション新規作成",
          titleIndex: "2.",
          level: TitleLevelEnum.second,
        },
        content: [
          {
            text: "アプリケーション一覧画面から、認証方式（APIキー / OAuth2.0）を選んでアプリケーションを新規作成します。",
            styleObject: { marginLeft: "24px" },
            type: ContentTypeEnum.link,
          },
          {
            text: "APIキー認証方式アプリケーションの新規作成手順は<a href='/tutorial/api-key' class='is-static-link' target='_blank'>こちら</a>をご参照ください。",
            styleObject: { marginLeft: "24px" },
            indexType: ContentIndexTypeEnum.circle,
            type: ContentTypeEnum.link,
          },
          {
            text: "OAuth2.0認証方式アプリケーションの新規作成手順は<a href='/tutorial/oauth' class='is-static-link' target='_blank'>こちら</a>をご参照ください。",
            styleObject: { marginLeft: "24px" },
            indexType: ContentIndexTypeEnum.circle,
            type: ContentTypeEnum.link,
          },
          {
            text: "APIキー / OAuth2.0の違いについては<a href='/guidelines' class='is-static-link' target='_blank'>こちら</a>をご参照ください。",
            styleObject: { marginLeft: "24px" },
            indexType: ContentIndexTypeEnum.circle,
            type: ContentTypeEnum.link,
          },
          {
            type: ContentTypeEnum.image,
            styleObject: { marginLeft: "24px" },
            image: {
              pcUrl: require("./images/applications.png"),
              pcMaxWidth: "600px",
              pcWidth: "100%",
              spUrl: require("./images/applications-sp.png"),
              spWidth: "319px",
              spMaxWidth: "319px",
            },
          },
        ],
      },
      {
        title: {
          text: "アプリケーション開発開始",
          titleIndex: "3.",
          level: TitleLevelEnum.second,
        },
        content: [
          {
            type: ContentTypeEnum.link,
            text: "以上でアプリケーションの開発を始めていただけます。開発のリファレンスはこちらをご確認ください。",
            styleObject: { marginLeft: "24px" },
          },
          {
            type: ContentTypeEnum.link,
            text: "<a class='is-static-link' href='/reference/api' target='_blank'>APIリファレンス</a>",
            styleObject: { marginLeft: "24px" },
            indexType: ContentIndexTypeEnum.circle,
          },
          {
            type: ContentTypeEnum.link,
            text: "<a class='is-static-link' href='/reference/sdk' target='_blank'>SDK(JavaScript)リファレンス</a>",
            styleObject: { marginLeft: "24px" },
            indexType: ContentIndexTypeEnum.circle,
          },
        ],
      },
    ],
  },
  {
    title: {
      text: "利用料金について",
    },
    content: [
      {
        text: "Safie APIおよびSafie SDK(JavaScript)の利用に必要な費用は、Safieのクラウド録画サービスのデバイスオプションの費用のみです。ディベロッパー（開発者）としての費用は発生しません。アプリケーションのご利用者（自身を含む）にオプション費用をご負担いただきます。",
      },
      {
        text: "なおトライアルプランの場合はオプションの申し込み不要で、無料でご利用いただけます。",
      },
      {
        text: "オプションについてはこちらをご確認ください。",
        type: ContentTypeEnum.link,
      },
      {
        type: ContentTypeEnum.link,
        text: "<a href='/terms-of-api?id=choose-list' class='is-static-link' target='_blank'>APIの機能制約</a>",
        styleObject: { marginLeft: "24px" },
        indexType: ContentIndexTypeEnum.circle,
      },
      {
        type: ContentTypeEnum.link,
        text: "<a href='/terms-of-api/sdk?id=choose-list' class='is-static-link' target='_blank'>SDK(JavaScript)の機能制約</a>",
        styleObject: { marginLeft: "24px" },
        indexType: ContentIndexTypeEnum.circle,
      },
      {
        text: "料金プランについて詳しくは<a class='is-static-link' href='https://safie.jp/contact/api/' target='_blank'>こちら</a>からお問い合わせください",
        type: ContentTypeEnum["tip-link"],
      },
    ],
  },
  {
    title: {
      text: "審査申請について",
    },
    content: [
      {
        text: "ディベロッパー登録直後は、アプリケーションを作成しても自身がオーナーアカウントのデバイスにしかアクセスすることができません。",
      },
      {
        text: "他のユーザーのデバイスにアクセスできるようにするためには事前審査が必要となっています。ディベロッパー情報ページより審査申請をしてください。審査では、法人の実在確認およびコンプライアンスチェックをさせていただきます。審査通過後、他のユーザーから許諾を得ることで、そのユーザーのデバイスにアクセスできるようになります。審査結果は原則5営業日以内にメールにて通知します。",
      },
      {
        text: "なお個人でディベロッパー登録されている方の審査は自動的に不通過となります。ご了承ください。",
      },
    ],
  },
];

const context: IStaticContext = {
  headerTitle: "Safie Developersの使い方",
  headerIcon: require("./images/header-icon.svg"),
  data,
};
export default context;
